import init from './init'


init.setupJqueryForBootstrap4();
init.logEnv();
init.setupTheme();
init.setupApp();
init.enableHotReloading();
